export const loggedIn = () => !!localStorage.token;
